import { Button } from 'antd'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import pushApi from '../../api/push.api'
import AppPushTemplates from '../../components/appPush/AppPushTemplates'
import styles from '../../styles/product.module.scss'
import { salusS3 } from '../../api/s3.api'

const AppPushTemplateRegisterPage = () => {
  const navigate = useNavigate()
  const [pushData, setPushData] = useState({
    title: '',
    pushTitle: '',
    pushBody: '',
    pushImageUrl: null,
    pushUrl: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setPushData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleImageChange = (info) => {
    if (info.fileList.length > 0) {
      setPushData((prev) => ({
        ...prev,
        pushImageUrl: info.fileList[0],
      }))
    } else {
      setPushData((prev) => ({
        ...prev,
        pushImageUrl: null,
      }))
    }
  }
  // useEffect(() => {
  //   console.log('pushData', pushData.pushImageUrl)
  // }, [pushData])

  const handleSave = async () => {
    try {
      const result = await Swal.fire({
        title: '푸시 템플릿 등록',
        html: `템플릿 제목: <b>${pushData.title}</b><br>으로 등록하시겠습니까?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: '등록',
        cancelButtonText: '취소',
        reverseButtons: true,
      })

      if (result.isConfirmed) {
        Swal.fire({
          title: '등록 중...',
          html: '템플릿을 등록하고 있습니다.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          },
        })

        const params = await createPushParams()
        const res = await pushApi.createAppPushTemplate(params)

        if (res.status === 200) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: '템플릿이 성공적으로 등록되었습니다.',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          })
          navigate('/appPush/templates')
        }
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '템플릿 등록 실패',
        text: error.message || '템플릿 등록 중 오류가 발생했습니다.',
      })
    }
  }

  const s3Upload = async () => {
    try {
      const now = new Date()
      const monthFolder = `${now.getFullYear()}-${String(
        now.getMonth() + 1,
      ).padStart(2, '0')}`
      const timestamp = Date.now()
      const random = Math.random().toString(36).substring(2, 8)
      const ext = pushData.pushImageUrl.type.split('/').pop() || ''

      const s3Path = `push/salus/template/${monthFolder}/${timestamp}-${random}.${ext}`
      let params = {
        Bucket: process.env.REACT_APP_S3_BUCKETNAME,
        Key: s3Path,
        Body: pushData.pushImageUrl.originFileObj,
      }
      let res = await salusS3.putObject(params).promise()

      if (res.$response.httpResponse.statusCode === 200) {
        return s3Path
      }
      return null
    } catch (error) {
      console.log(error)
      return null
    }
  }

  // 푸시 발송 파라미터 생성
  const createPushParams = async () => {
    let imageUrl = null
    if (pushData.pushImageUrl) {
      const s3Path = await s3Upload()
      if (!s3Path) {
        throw new Error('이미지 업로드에 실패했습니다.')
      }
      imageUrl = `${process.env.REACT_APP_S3_HOST}/${s3Path}`
    }

    const params = {
      title: pushData.title,
      pushTitle: pushData.pushTitle,
      pushBody: pushData.pushBody,
      pushUrl: pushData.pushUrl || null,
      pushImageUrl: imageUrl,
    }

    if (!validatePushParams(params)) {
      return null
    }

    return params
  }
  // 푸시 발송 파라미터 검증
  const validatePushParams = (params) => {
    const errors = []

    if (!params.title?.trim()) {
      errors.push('템플릿 이름을 입력해주세요.')
    }
    if (!params.pushTitle?.trim()) {
      errors.push('푸시 제목을 입력해주세요.')
    }
    if (!params.pushBody?.trim()) {
      errors.push('푸시 내용을 입력해주세요.')
    }

    if (errors.length > 0) {
      alert(errors.join('\n'))
      return false
    } else {
      return true
    }
  }
  return (
    <div>
      <AppPushTemplates
        headerTitle="푸시 템플릿 등록"
        pushData={pushData}
        handleChange={handleChange}
        handleImageChange={handleImageChange}
      />
      <div className={`${styles['product-register-fixed-footer']}`}>
        <Button type="primary" onClick={handleSave}>
          저장
        </Button>
      </div>
    </div>
  )
}

export default AppPushTemplateRegisterPage
